/* eslint-disable no-console */
export const sendEmail = (email: string, subject?: string, body?: string): void => {
	try {
		let mailtoUrl = `mailto:${email}`;

		const params: string[] = [];

		if (subject) {
			params.push(`subject=${encodeURIComponent(subject)}`);
		}

		if (body) {
			params.push(`body=${encodeURIComponent(body)}`);
		}

		if (params.length > 0) {
			mailtoUrl += `?${params.join('&')}`;
		}

		window.location.href = mailtoUrl;
	} catch (error) {
		console.error('Erro ao abrir cliente de email:', error);
	}
};
